// © 2015-2021 WDNA - All Rights Reserved

import { RedirectProps, RouteProps } from 'react-router';

import Companies from './loaders/Companies';
import Customers from './loaders/Customers';
import Locations from './loaders/Locations';
import System from './loaders/System';

export const redirects: RedirectProps[] = [
  {
    from: '/management',
    to: '/management/customers',
  },
];

export const routes: RouteProps[] = [
  {
    component: Companies,
    path: '/management/companies',
  },
  {
    component: Customers,
    path: '/management/customers',
  },
  {
    component: Locations,
    path: '/management/locations',
  },
  {
    component: System,
    path: '/management/system',
  },
];
